module.exports = __webpack_public_path__ + "ls.svg?6497b847f86af3b088814ff131f87ff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ls.svg
// module id = 1472
// module chunks = 0